export default __webpack_public_path__ + "static/media/game.102c5a6c.jpg";